/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/calls.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Calls redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Monday, February 10, 2025 - 1:08 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2025/02/10  NJN Initial Build
 *
 *  Copyright (c) 2025 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  callid: 0,
  error: null,
  defaultToolPanel: "filter",
  order: "NAME ASC",
  search: "",
  fCallID: 0,
  columnState: [],
};

const intFields = ["callid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const sessionSlice = createSlice({
  name: "calls",
  initialState,
  reducers: {
    updateCallID: (state, action) => updateFieldReducer(state, action, "callid"),
    updateSearch: (state, action) => updateFieldReducer(state, action, "search"),
    updateFCallID: (state, action) => updateFieldReducer(state, action, "fCallID"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
  },
});

export const { updateCallID, updateSearch, updateFCallID, updateDefaultToolPanel, updateColumnState } =
  sessionSlice.actions;

export default sessionSlice.reducer;
